import React from 'react';

import cn from 'classnames';
import dayjs from 'dayjs';
import Image from 'next/legacy/image';
import Link from 'next/link';

import { NEWS_PATHS } from '@constants/index';
import I18n from '@utils/i18n';
import { isValidSource } from '@utils/sundries'

import styles from './index.module.less';

const Title = ({ children, tgaName: TagName }) => {
  return (
    <TagName className={styles.p}>
      {children}
    </TagName>
  );
};

const renderImage = (images) => {
  const srcList = images?.filter(src => isValidSource(src, 'image'));
  if (srcList?.length) {
    return (<Image
      src={srcList[0]}
      width="310"
      height="120"
      className={styles.cardImg}
    />
    )
  }
  return <div className={styles.illegalImg}>{I18n.t('Kmmg8uqw')}</div>;
}

export const Card = ({ item, tgaName }) => {
  return (
    <Link key={item.id} href={`${NEWS_PATHS.POST}/${item.id}?type=2`} data-buried='ZX-03'>
      <a target="_black" className={styles.item} title={item.title}>
        <div className={cn(styles.img, styles.h5Img)}>
          {renderImage(item?.images)}
        </div>
        <Title tgaName={tgaName}>{item.title}</Title>
        <p className={styles.footer}>
          <span className={styles.time}>
            {dayjs(item.timestamp).format('YYYY-MM-DD HH:mm:ss')}
          </span>
          <Link legacyBehavior href={item.link}>
            <a className={styles.link} target="_black" data-buried='ZX-04'>
              {item.linkText}
            </a>
          </Link>
        </p>
      </a>
    </Link>
  );
};

export const HotNews = (props) => {
  const { recommend, asideTag: { postTitle, moduleTitle: ModuleTitle } } = props;
  return (
    <div className={styles.container}>
      <ModuleTitle className={cn(styles.h3, 'Medium')}>{I18n.t('aTB67xOm')}</ModuleTitle>
      {recommend?.result?.map((item) => {
        return <Card item={item} key={item.id} tgaName={postTitle} />;
      })}
    </div>
  );
};
